import { useEffect, useState } from "react";

/** How many fixed-width decorative units are needed to span the viewport. */
export function useFillCount(unit, max = 90) {
  const read = () => Math.min(max, Math.max(4, Math.ceil(window.innerWidth / unit)));
  const [n, setN] = useState(read);
  useEffect(() => {
    const on = () => setN(read());
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, [unit, max]); // eslint-disable-line react-hooks/exhaustive-deps
  return n;
}
